import { useEffect, useRef } from 'react';

export const useEffectButSkipMount: typeof useEffect = (callback, deps) => {
  const mountDidHappen = useRef(false);

  useEffect(() => {
    if (!mountDidHappen.current) {
      mountDidHappen.current = true;
      return;
    }

    return callback();
  }, deps);
};
